export default {
  methods: {
    appendLeadingZeroes(n) {
      if (n <= 9) {
        return `0${n}`
      }
      return n
    },
    getDateWithTimeZone(dt, timeZone) {
      if (!timeZone) {
        timeZone = 'Europe/Tallinn'
      }
      const timeInTimeZone = new Date(
        new Date().toLocaleString('en-US', { timeZone })
      ).getTime()
      const localTime = new Date().getTime()
      const hoursDifference = Math.round(
        (localTime - timeInTimeZone) / (1000 * 60 * 60)
      )
      dt = new Date(dt)
      dt.setHours(dt.getHours() + hoursDifference)
      return dt
    },
    getDateInTimeZone(dt, timeZone) {
      if (!timeZone) {
        timeZone = 'Europe/Tallinn'
      }
      if (!dt || dt === '0001-01-01T00:00:00Z') {
        return ''
      }
      dt = new Date(new Date(dt).toLocaleString('en-US', { timeZone }))
      return dt
    },
    formatDate(dt) {
      if (!(dt instanceof Date)) {
        return ''
      }
      const year = dt.getFullYear()
      const month = String(dt.getMonth() + 1).padStart(2, '0')
      const day = String(dt.getDate()).padStart(2, '0')
      return `${day}.${month}.${year}`
    },
    formatDateISO(dt) {
      if (!(dt instanceof Date)) {
        return ''
      }
      const year = dt.getFullYear()
      const month = String(dt.getMonth() + 1).padStart(2, '0')
      const day = String(dt.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    dateEE(dateParts, delimeter = '.', withTime = true) {
      if (dateParts === '0001-01-01T00:00:00Z') return null
      const date = new Date(Date.parse(dateParts))
      let formattedDate = ''
      if (withTime) {
        formattedDate = `${this.appendLeadingZeroes(
          date.getDate()
        )}${delimeter}${this.appendLeadingZeroes(
          date.getMonth() + 1
        )}${delimeter}${date
          .getFullYear()
          .toString()
          .substr(-2)} ${this.appendLeadingZeroes(
          date.getHours()
        )}:${this.appendLeadingZeroes(date.getMinutes())}`
      } else {
        formattedDate = `${this.appendLeadingZeroes(
          date.getDate()
        )}${delimeter}${this.appendLeadingZeroes(
          date.getMonth() + 1
        )}${delimeter}${date
          .getFullYear()
          .toString()
          .substr(-2)}`
      }
      return formattedDate
    },
    formattedDate(dateParts, withoutTime, delimeter = '.', withoutZeros) {
      if (dateParts === '0001-01-01T00:00:00Z') return null
      const date = new Date(Date.parse(dateParts))
      let formattedDate
      if (!withoutZeros) {
        if (withoutTime) {
          formattedDate = `${this.appendLeadingZeroes(
            date.getDate()
          )}${delimeter}${this.appendLeadingZeroes(
            date.getMonth() + 1
          )}${delimeter}${date
            .getFullYear()
            .toString()
            .substr(-2)}`
        } else {
          formattedDate = `${this.appendLeadingZeroes(
            date.getDate()
          )}.${this.appendLeadingZeroes(date.getMonth() + 1)}.${date
            .getFullYear()
            .toString()
            .substr(-2)} ${this.appendLeadingZeroes(
            date.getHours()
          )}:${this.appendLeadingZeroes(date.getMinutes())}`
        }
      } else if (withoutTime) {
        formattedDate = `${date.getDate()}${delimeter}${date.getMonth() +
          1}${delimeter}${date
          .getFullYear()
          .toString()
          .substr(-2)}`
      } else {
        formattedDate = `${date.getDate()}.${date.getMonth() + 1}.${date
          .getFullYear()
          .toString()
          .substr(-2)} ${this.appendLeadingZeroes(
          date.getHours()
        )}:${this.appendLeadingZeroes(date.getMinutes())}`
      }
      if (withoutTime) {
        formattedDate = `${date.getDate()}${delimeter}${date.getMonth() +
          1}${delimeter}${date
          .getFullYear()
          .toString()
          .substr(-2)}`
      } else {
        formattedDate = `${date.getDate()}.${date.getMonth() + 1}.${date
          .getFullYear()
          .toString()
          .substr(-2)} ${date.getHours()}:${this.appendLeadingZeroes(
          date.getMinutes()
        )}`
      }
      return formattedDate
    }
  }
}
